import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import RentabloLogo from "./images/rentablo-logo-round.svg?react";

export const SupportCardAnonymous = ({
  align = "left",
}: {
  align?: "left" | "center";
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={align === "left" ? "flex-start" : "center"}
      gap={2}
      sx={{
        circle: {
          fill: theme.palette.background.paper,
          stroke: theme.palette.border.secondary,
        },
      }}
    >
      <RentabloLogo />
      <Typography variant="body1" color="textSecondary">
        {t("supportCard.subtitle")}
      </Typography>
    </Box>
  );
};
